import React from 'react'

import Routes from './routes'

const ManageData = () => {
  return <Routes />
}

export default ManageData
